export const TID = {
  // Marketing / auth
  landingHero: "landing-hero",
  landingCtaLogin: "landing-cta-login",
  landingCtaProduct: "landing-cta-product",
  landingArchitecture: "landing-architecture",
  loginGoogleBtn: "login-google-btn",
  loginSsoEntra: "login-sso-entra",
  loginSsoOkta: "login-sso-okta",
  loginSsoAuth0: "login-sso-auth0",
  loginSsoKeycloak: "login-sso-keycloak",
  authCallbackStatus: "auth-callback-status",

  // Shell
  appShell: "app-shell",
  sidebar: "app-sidebar",
  topbar: "app-topbar",
  tenantSwitcher: "tenant-switcher",
  userMenu: "user-menu",
  logoutBtn: "logout-btn",
  navDashboard: "nav-dashboard",
  navConsumers: "nav-consumers",
  navProfile: "nav-profile",
  navTimeline: "nav-timeline",
  navEvidence: "nav-evidence",
  navRecommendations: "nav-recommendations",
  navLearning: "nav-learning",
  navAssessments: "nav-assessments",
  navReports: "nav-reports",
  navIntegrations: "nav-integrations",
  navAdministration: "nav-administration",

  // Dashboard
  dashboard: "dashboard",
  kpiTotalConsumers: "kpi-total-consumers",
  kpiOpenRecs: "kpi-open-recommendations",
  kpiEvidence: "kpi-evidence-records",
  kpiTrust: "kpi-trust-score",
  trustTrendChart: "trust-trend-chart",
  categoryBreakdownChart: "category-breakdown-chart",
  recentEventsList: "recent-events-list",

  // Consumers
  consumersPage: "consumers-page",
  consumersSearch: "consumers-search",
  consumersTable: "consumers-table",
  consumerRow: "consumer-row",

  // Consumer Profile
  profilePage: "profile-page",
  profileHeader: "profile-header",
  profileTrustBadge: "profile-trust-badge",
  profileEvaluateBtn: "profile-evaluate-btn",
  profileCertificateBtn: "profile-certificate-btn",
  profileTabsOverview: "profile-tab-overview",
  profileTabsTimeline: "profile-tab-timeline",
  profileTabsEvidence: "profile-tab-evidence",
  profileTabsRecommendations: "profile-tab-recommendations",
  profileTabsLearning: "profile-tab-learning",
  profileTabsAssessments: "profile-tab-assessments",

  // Evidence
  evidencePage: "evidence-page",
  evidenceTable: "evidence-table",

  // Recommendations
  recommendationsPage: "recommendations-page",
  recommendationsList: "recommendations-list",
  recUpdateStatus: "rec-update-status",

  // Learning / Assessments / Reports / Integrations / Admin
  learningPage: "learning-page",
  assessmentsPage: "assessments-page",
  reportsPage: "reports-page",
  integrationsPage: "integrations-page",
  administrationPage: "administration-page",
  timelinePage: "timeline-page",
};
